import {
  CacheAddress,
  CacheCompany,
  CacheZipCodeState
} from '@core/data-access/models/shared/google-maps-api-cache.model';
import { createActionGroup, props } from '@ngrx/store';

export const GoogleMapsApiCacheActions = createActionGroup({
  source: 'Google maps api cache',
  events: {
    'Cache address': props<CacheAddress>(),
    'Cache company': props<CacheCompany>(),
    'Cache zip code state': props<CacheZipCodeState>()
  }
});

export type CachePlaceDetailsAction =
  | typeof GoogleMapsApiCacheActions.cacheAddress
  | typeof GoogleMapsApiCacheActions.cacheCompany;
